import { useCallback, useState } from 'react'
import '../assets/css/Prijava.css'
import '../assets/css/ResetPassword.css'
import { Button, Form, Input } from "antd"
import { containsANumberAndUppercaseLetter } from '../services/CommonService'
import { validAuthParameter } from '../services/ProtectedRouteService'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import noRefreshClient from '../services/api/NoRefreshClient'
import { useModalContext } from '../context/ModalContext'
import { MODAL_DESCRIPTION_ERROR_RESET_PASSWORD, MODAL_DESCRIPTION_SUCCESS_RESET_PASSWORD, MODAL_MESSAGE_ERROR, MODAL_MESSAGE_SUCCESS_REQUEST, MODAL_TYPE_ERROR, MODAL_TYPE_SUCCESS, OK_RESPONSE } from '../HistoriografijaConstants'

function ResetPassword() {
    const [form] = Form.useForm()
    const { displayMessageModalWithParameters, displayGenericErrorModal, resetModalContext } = useModalContext()

    const location = useLocation()
    const authParameter = new URLSearchParams(location.search)?.get('auth')
    const initialUserEmail = validAuthParameter(authParameter)
    const [userEmail] = useState(initialUserEmail)

    const navigate = useNavigate()

    const submitForm = useCallback((values) => {
        form.validateFields({validateOnly: true})
        .then(async () => {
            var formData = new FormData();
            formData.append("newPassword", values.password)
            formData.append("confirmNewPassword", values.confirmPassword)
            formData.append("token", authParameter)
            return noRefreshClient.post('users/saveNewPassword', formData)
            .then(data => {
                if (data.status === 200) {
                    if (data.data === OK_RESPONSE) {
                        displayMessageModalWithParameters(MODAL_MESSAGE_SUCCESS_REQUEST, MODAL_DESCRIPTION_SUCCESS_RESET_PASSWORD, MODAL_TYPE_SUCCESS)
                        // Redirect the user to home page after 5 seconds
                        setTimeout(() => {
                            navigate('/')
                            resetModalContext()
                        }, 5000)
                    }
                } else {
                    displayGenericErrorModal()
                    form.resetFields()
                }
            })
            .catch(error => {
                if (error?.response?.status === 401) {
                    displayMessageModalWithParameters(MODAL_MESSAGE_ERROR, MODAL_DESCRIPTION_ERROR_RESET_PASSWORD, MODAL_TYPE_ERROR)
                    // Redirect the user to home page after 5 seconds
                    setTimeout(() => {
                        navigate('/')
                        resetModalContext()
                    }, 5000)
                } else {
                    displayGenericErrorModal()
                    form.resetFields()
                }
            })
        })
    }, [form, authParameter, displayMessageModalWithParameters, navigate, resetModalContext, displayGenericErrorModal])

    const goToStartPage = useCallback(() => {
        navigate("/")
    }, [navigate])

    return (
        userEmail ?
        <div className="Prijava centered-narrow-div">
                <div className="PrijavaForm">
                    <Form form={form} onFinish={submitForm} className="Form" noValidate scrollToFirstError>
                        <h2 className="FormTitle">RESET LOZINKE</h2>

                        <Form.Item name="password"
                            className="formItem"                         
                            rules={[
                                () => ({
                                    validator(_, value) {
                                        if (value) {
                                            if (value.length !== 0 && value.length < 8) {
                                                return Promise.reject(new Error('Lozinka je prekratka. Potrebno je da ima najmanje 8 karaktera'))
                                            } else if (value.length > 30) {
                                                return Promise.reject(new Error('Lozinka je preduga'))
                                            } else if (!containsANumberAndUppercaseLetter(value)) {
                                                return Promise.reject(new Error('Lozinka treba da sadrži najmanje 1 broj i najmanje 1 veliko slovo'))
                                            }
                                            return Promise.resolve()
                                        }
                                        return Promise.reject(new Error('Lozinka je obavezno polje'))
                                    },
                                })
                            ]}
                        >
                            <div>
                                <Input.Password
                                    type="password"
                                    placeholder="Nova lozinka"
                                    className="inputField"
                                />
                                <p className="field-description">Lozinka treba da sadrži najmanje 8 karaktera, 1 broj, 1 veliko slovo</p>
                            </div>
                        </Form.Item>

                        <Form.Item name="confirmPassword"
                            className="formItem"                         
                            rules={[
                                {
                                    required: true,
                                    message: 'Potvrdite novu lozinku',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Lozinke se ne slažu'));
                                    },
                                })
                        ]}>
                            <Input.Password
                                type="password"
                                placeholder="Potvrdite novu lozinku"
                                className="inputField"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button htmlType="submit" className="login-form-button custom-button primaryButton">
                                RESETUJ LOZINKU
                            </Button>
                        </Form.Item>

                        <Form.Item>
                            <Button onClick={goToStartPage} className="login-form-button custom-button secondaryButton button-as-link">
                                Povratak na početnu stranicu
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            :
            <Navigate to="/" replace={true} />
    )
}

export default ResetPassword